import type { WorkspaceCreateForNewClientDto } from '@/types/company'

/** The first-workspace step of Add Customer, as react-hook-form holds it. */
export type NewClientWorkspaceForm = {
    Name: string
    Slug: string
    Description?: string
    Status?: string
    TimeZone: string
    Locale?: string
    DailyLeadsSummaryEnabled: boolean
    DailyLeadsSummaryHour: number
    PostWebinarSummaryEnabled: boolean
    StartOfWeekSummaryEnabled: boolean
    StartOfWeekSummaryDayOfWeek: number
    StartOfWeekSummaryHour: number
}

// Defaults match the entity's, so an untouched form creates exactly what an omitted field would.
export const emptyNewClientWorkspaceForm = (): NewClientWorkspaceForm => ({
    Name: '',
    Slug: '',
    Description: '',
    Status: 'Active',
    TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
    Locale: '',
    DailyLeadsSummaryEnabled: false,
    DailyLeadsSummaryHour: 8,
    PostWebinarSummaryEnabled: false,
    StartOfWeekSummaryEnabled: false,
    StartOfWeekSummaryDayOfWeek: 1,
    StartOfWeekSummaryHour: 8,
})

/**
 * Every field WorkspaceFormFields renders has to be copied here, or a ticked box is dropped on save.
 * The daily leads summary was, until ORB-1034. The selects hand back strings, hence the Number().
 */
export const toNewClientWorkspace = (form: NewClientWorkspaceForm): WorkspaceCreateForNewClientDto => ({
    Name: form.Name.trim(),
    Slug: form.Slug.trim(),
    Description: form.Description?.trim() || undefined,
    Status: form.Status?.trim() || undefined,
    TimeZone: form.TimeZone.trim(),
    Locale: form.Locale?.trim() || undefined,
    DailyLeadsSummaryEnabled: form.DailyLeadsSummaryEnabled,
    DailyLeadsSummaryHour: Number(form.DailyLeadsSummaryHour),
    PostWebinarSummaryEnabled: form.PostWebinarSummaryEnabled,
    StartOfWeekSummaryEnabled: form.StartOfWeekSummaryEnabled,
    StartOfWeekSummaryDayOfWeek: Number(form.StartOfWeekSummaryDayOfWeek),
    StartOfWeekSummaryHour: Number(form.StartOfWeekSummaryHour),
})
